const countries = [
  { countryId: 127249, value: 'Afghanistan', code: 'AF' },
  { countryId: 127252, value: 'Albania', code: 'AL' },
  { countryId: 127307, value: 'Algeria', code: 'DZ' },
  { countryId: 127258, value: 'American Samoa', code: 'AS' },
  { countryId: 127247, value: 'Andorra', code: 'AD' },
  { countryId: 127255, value: 'Angola', code: 'AO' },
  { countryId: 127251, value: 'Anguilla', code: 'AI' },
  { countryId: 127256, value: 'Antarctica', code: 'AQ' },
  { countryId: 127250, value: 'Antigua And Barbuda', code: 'AG' },
  { countryId: 127257, value: 'Argentina', code: 'AR' },
  { countryId: 127253, value: 'Armenia', code: 'AM' },
  { countryId: 127261, value: 'Aruba', code: 'AW' },
  { countryId: 127260, value: 'Australia', code: 'AU' },
  { countryId: 127259, value: 'Austria', code: 'AT' },
  { countryId: 127262, value: 'Åland Islands', code: 'AX' },
  { countryId: 127263, value: 'Azerbaijan', code: 'AZ' },
  { countryId: 127278, value: 'Bahamas', code: 'BS' },
  { countryId: 127270, value: 'Bahrain', code: 'BH' },
  { countryId: 127266, value: 'Bangladesh', code: 'BD' },
  { countryId: 127265, value: 'Barbados', code: 'BB' },
  { countryId: 127282, value: 'Belarus', code: 'BY' },
  { countryId: 127267, value: 'Belgium', code: 'BE' },
  { countryId: 127283, value: 'Belize', code: 'BZ' },
  { countryId: 127272, value: 'Benin', code: 'BJ' },
  { countryId: 127274, value: 'Bermuda', code: 'BM' },
  { countryId: 127279, value: 'Bhutan', code: 'BT' },
  { countryId: 127276, value: 'Bolivia', code: 'BO' },
  { countryId: 127264, value: 'Bosnia And Herzegovina', code: 'BA' },
  { countryId: 127281, value: 'Botswana', code: 'BW' },
  { countryId: 127280, value: 'Bouvet Island', code: 'BV' },
  { countryId: 127277, value: 'Brazil', code: 'BR' },
  { countryId: 127346, value: 'British Indian Ocean Territory', code: 'IO' },
  { countryId: 127275, value: 'Brunei Darussalam', code: 'BN' },
  { countryId: 127269, value: 'Bulgaria', code: 'BG' },
  { countryId: 127268, value: 'Burkina Faso', code: 'BF' },
  { countryId: 127271, value: 'Burundi', code: 'BI' },
  { countryId: 127357, value: 'Cambodia', code: 'KH' },
  { countryId: 127293, value: 'Cameroon', code: 'CM' },
  { countryId: 127284, value: 'Canada', code: 'CA' },
  { countryId: 127298, value: 'Cape Verde', code: 'CV' },
  { countryId: 127364, value: 'Cayman Islands', code: 'KY' },
  { countryId: 127287, value: 'Central African Republic', code: 'CF' },
  { countryId: 127454, value: 'Chad', code: 'TD' },
  { countryId: 127292, value: 'Chile', code: 'CL' },
  { countryId: 127294, value: 'China', code: 'CN' },
  { countryId: 127299, value: 'Christmas Island', code: 'CX' },
  { countryId: 127285, value: 'Cocos (keeling) Islands', code: 'CC' },
  { countryId: 127295, value: 'Colombia', code: 'CO' },
  { countryId: 127359, value: 'Comoros', code: 'KM' },
  { countryId: 127288, value: 'Congo', code: 'CG' },
  { countryId: 127286, value: 'Congo, The Democratic Republic Of The', code: 'CD' },
  { countryId: 127291, value: 'Cook Islands', code: 'CK' },
  { countryId: 127296, value: 'Costa Rica', code: 'CR' },
  { countryId: 127340, value: 'Croatia', code: 'HR' },
  { countryId: 127297, value: 'Cuba', code: 'CU' },
  { countryId: 127300, value: 'Cyprus', code: 'CY' },
  { countryId: 127301, value: 'Czech Republic', code: 'CZ' },
  { countryId: 127290, value: 'Côte D\'ivoire', code: 'CI' },
  { countryId: 127304, value: 'Denmark', code: 'DK' },
  { countryId: 127303, value: 'Djibouti', code: 'DJ' },
  { countryId: 127305, value: 'Dominica', code: 'DM' },
  { countryId: 127306, value: 'Dominican Republic', code: 'DO' },
  { countryId: 127308, value: 'Ecuador', code: 'EC' },
  { countryId: 127310, value: 'Egypt', code: 'EG' },
  { countryId: 127450, value: 'El Salvador', code: 'SV' },
  { countryId: 127332, value: 'Equatorial Guinea', code: 'GQ' },
  { countryId: 127312, value: 'Eritrea', code: 'ER' },
  { countryId: 127309, value: 'Estonia', code: 'EE' },
  { countryId: 127314, value: 'Ethiopia', code: 'ET' },
  { countryId: 127317, value: 'Falkland Islands (malvinas)', code: 'FK' },
  { countryId: 127319, value: 'Faroe Islands', code: 'FO' },
  { countryId: 127316, value: 'Fiji', code: 'FJ' },
  { countryId: 127315, value: 'Finland', code: 'FI' },
  { countryId: 1276, value: 'France', code: 'FR' },
  { countryId: 127324, value: 'French Guiana', code: 'GF' },
  { countryId: 127417, value: 'French Polynesia', code: 'PF' },
  { countryId: 127455, value: 'French Southern Territories', code: 'TF' },
  { countryId: 127320, value: 'Gabon', code: 'GA' },
  { countryId: 127329, value: 'Gambia', code: 'GM' },
  { countryId: 127323, value: 'Georgia', code: 'GE' },
  { countryId: 127302, value: 'Germany', code: 'DE' },
  { countryId: 127326, value: 'Ghana', code: 'GH' },
  { countryId: 127327, value: 'Gibraltar', code: 'GI' },
  { countryId: 1090, value: 'Greece - Ελλάδα', code: 'GR' },
  { countryId: 127328, value: 'Greenland', code: 'GL' },
  { countryId: 127322, value: 'Grenada', code: 'GD' },
  { countryId: 127331, value: 'Guadeloupe', code: 'GP' },
  { countryId: 127335, value: 'Guam', code: 'GU' },
  { countryId: 127334, value: 'Guatemala', code: 'GT' },
  { countryId: 127325, value: 'Guernsey', code: 'GG' },
  { countryId: 127330, value: 'Guinea', code: 'GQ' },
  { countryId: 127336, value: 'Guinea-bissau', code: 'GW' },
  { countryId: 127337, value: 'Guyana', code: 'GY' },
  { countryId: 127341, value: 'Haiti', code: 'HT' },
  { countryId: 127338, value: 'Heard Island And Mcdonald Islands', code: 'HM' },
  { countryId: 127475, value: 'Holy See (vatican City State)', code: 'VA' },
  { countryId: 127339, value: 'Honduras', code: 'HN' },
  { countryId: 10859, value: 'Hong Kong', code: 'HK' },
  { countryId: 127342, value: 'Hungary', code: 'HU' },
  { countryId: 127349, value: 'Iceland', code: 'IS' },
  { countryId: 127489, value: 'India', code: 'IO' },
  { countryId: 127343, value: 'Indonesia', code: 'ID' },
  { countryId: 127348, value: 'Iran, Islamic Republic Of', code: 'IR' },
  { countryId: 127347, value: 'Iraq', code: 'IQ' },
  { countryId: 127344, value: 'Ireland', code: 'IE' },
  { countryId: 127345, value: 'Isle Of Man', code: 'IM' },
  { countryId: 1247, value: 'Israel', code: 'IL' },
  { countryId: 127350, value: 'Italy', code: 'IT' },
  { countryId: 127352, value: 'Jamaica', code: 'JM' },
  { countryId: 127354, value: 'Japan', code: 'JP' },
  { countryId: 127351, value: 'Jersey', code: 'JE' },
  { countryId: 127353, value: 'Jordan', code: 'JO' },
  { countryId: 127365, value: 'Kazakhstan', code: 'KZ' },
  { countryId: 127355, value: 'Kenya', code: 'KE' },
  { countryId: 127358, value: 'Kiribati', code: 'KI' },
  { countryId: 127361, value: 'Korea, Democratic People\'s Republic Of', code: 'KP' },
  { countryId: 127362, value: 'Korea, Republic Of', code: 'KR' },
  { countryId: 127363, value: 'Kuwait', code: 'KW' },
  { countryId: 127356, value: 'Kyrgyzstan', code: 'KG' },
  { countryId: 127366, value: 'Lao People\'s Democratic Republic', code: 'LA' },
  { countryId: 127378, value: 'Latvia', code: 'LV' },
  { countryId: 127367, value: 'Lebanon', code: 'LB' },
  { countryId: 127375, value: 'Lesotho', code: 'LS' },
  { countryId: 127374, value: 'Liberia', code: 'LR' },
  { countryId: 127379, value: 'Libyan Arab Jamahiriya', code: 'LY' },
  { countryId: 127372, value: 'Liechtenstein', code: 'LI' },
  { countryId: 127376, value: 'Lithuania', code: 'LT' },
  { countryId: 127377, value: 'Luxembourg', code: 'LU' },
  { countryId: 127390, value: 'Macao', code: 'MO' },
  { countryId: 127386, value: 'Macedonia, The Former Yugoslav Republic Of', code: 'MK' },
  { countryId: 127384, value: 'Madagascar', code: 'MG' },
  { countryId: 127398, value: 'Malawi', code: 'MW' },
  { countryId: 127400, value: 'Malaysia', code: 'MY' },
  { countryId: 127397, value: 'Maldives', code: 'MV' },
  { countryId: 127387, value: 'Mali', code: 'ML' },
  { countryId: 127395, value: 'Malta', code: 'MT' },
  { countryId: 127385, value: 'Marshall Islands', code: 'MH' },
  { countryId: 127392, value: 'Martinique', code: 'MQ' },
  { countryId: 127393, value: 'Mauritania', code: 'MR' },
  { countryId: 127396, value: 'Mauritius', code: 'MU' },
  { countryId: 127485, value: 'Mayotte', code: 'YT' },
  { countryId: 127399, value: 'Mexico', code: 'MX' },
  { countryId: 127318, value: 'Micronesia, Federated States Of', code: 'FM' },
  { countryId: 127381, value: 'Moldova, Republic Of', code: 'MD' },
  { countryId: 40525, value: 'Monaco', code: 'MC' },
  { countryId: 127389, value: 'Mongolia', code: 'MN' },
  { countryId: 127382, value: 'Montenegro', code: 'ME' },
  { countryId: 127394, value: 'Montserrat', code: 'MS' },
  { countryId: 127380, value: 'Morocco', code: 'MA' },
  { countryId: 127401, value: 'Mozambique', code: 'MZ' },
  { countryId: 127388, value: 'Myanmar', code: 'MM' },
  { countryId: 127402, value: 'Namibia', code: 'NA' },
  { countryId: 127411, value: 'Nauru', code: 'NR' },
  { countryId: 127410, value: 'Nepal', code: 'NP' },
  { countryId: 127408, value: 'Netherlands', code: 'NL' },
  { countryId: 127254, value: 'Netherlands Antilles', code: 'AN' },
  { countryId: 127403, value: 'New Caledonia', code: 'NC' },
  { countryId: 127413, value: 'New Zealand', code: 'NZ' },
  { countryId: 127407, value: 'Nicaragua', code: 'NI' },
  { countryId: 127404, value: 'Niger', code: 'NE' },
  { countryId: 127406, value: 'Nigeria', code: 'NG' },
  { countryId: 127412, value: 'Niue', code: 'NU' },
  { countryId: 127405, value: 'Norfolk Island', code: 'NF' },
  { countryId: 127391, value: 'Northern Mariana Islands', code: 'MP' },
  { countryId: 127409, value: 'Norway', code: 'NO' },
  { countryId: 127414, value: 'Oman', code: 'OM' },
  { countryId: 127420, value: 'Pakistan', code: 'PK' },
  { countryId: 127427, value: 'Palau', code: 'PW' },
  { countryId: 127425, value: 'Palestinian Territory, Occupied', code: 'PS' },
  { countryId: 127415, value: 'Panama', code: 'PA' },
  { countryId: 127418, value: 'Papua New Guinea', code: 'PG' },
  { countryId: 127428, value: 'Paraguay', code: 'PY' },
  { countryId: 127416, value: 'Peru', code: 'PE' },
  { countryId: 127419, value: 'Philippines', code: 'PH' },
  { countryId: 127423, value: 'Pitcairn', code: 'PN' },
  { countryId: 127421, value: 'Poland', code: 'PL' },
  { countryId: 127426, value: 'Portugal', code: 'PT' },
  { countryId: 127424, value: 'Puerto Rico', code: 'PR' },
  { countryId: 127429, value: 'Qatar', code: 'QA' },
  { countryId: 127430, value: 'Reunion', code: 'RE' },
  { countryId: 127431, value: 'Romania', code: 'RO' },
  { countryId: 127433, value: 'Russian Federation', code: 'RU' },
  { countryId: 127434, value: 'Rwanda', code: 'RW' },
  { countryId: 127273, value: 'Saint Barthélemy', code: 'BL' },
  { countryId: 127440, value: 'Saint Helena', code: 'SH' },
  { countryId: 127360, value: 'Saint Kitts And Nevis', code: 'KN' },
  { countryId: 127371, value: 'Saint Lucia', code: 'LC' },
  { countryId: 127383, value: 'Saint Martin', code: 'MF' },
  { countryId: 127422, value: 'Saint Pierre And Miquelon', code: 'PM' },
  { countryId: 127476, value: 'Saint Vincent And The Grenadines', code: 'VC' },
  { countryId: 127483, value: 'Samoa', code: 'AS' },
  { countryId: 127445, value: 'San Marino', code: 'SM' },
  { countryId: 127449, value: 'Sao Tome And Principe', code: 'ST' },
  { countryId: 127435, value: 'Saudi Arabia', code: 'SA' },
  { countryId: 127446, value: 'Senegal', code: 'SN' },
  { countryId: 127432, value: 'Serbia', code: 'RS' },
  { countryId: 127437, value: 'Seychelles', code: 'SC' },
  { countryId: 127444, value: 'Sierra Leone', code: 'SL' },
  { countryId: 5051, value: 'Singapore', code: 'SG' },
  { countryId: 127443, value: 'Slovakia', code: 'SK' },
  { countryId: 127441, value: 'Slovenia', code: 'SI' },
  { countryId: 127436, value: 'Solomon Islands', code: 'SB' },
  { countryId: 127447, value: 'Somalia', code: 'SO' },
  { countryId: 127486, value: 'South Africa', code: 'ZA' },
  { countryId: 127333, value: 'South Georgia And The South Sandwich Islands', code: 'GS' },
  { countryId: 127313, value: 'Spain', code: 'ES' },
  { countryId: 127373, value: 'Sri Lanka', code: 'LK' },
  { countryId: 127438, value: 'Sudan', code: 'SS' },
  { countryId: 127448, value: 'Suriname', code: 'SR' },
  { countryId: 127442, value: 'Svalbard And Jan Mayen', code: 'SJ' },
  { countryId: 127452, value: 'Swaziland', code: 'SZ' },
  { countryId: 127439, value: 'Sweden', code: 'SE' },
  { countryId: 127289, value: 'Switzerland', code: 'CH' },
  { countryId: 127451, value: 'Syrian Arab Republic', code: 'SY' },
  { countryId: 127467, value: 'Taiwan, Province Of China', code: 'TW' },
  { countryId: 127458, value: 'Tajikistan', code: 'TJ' },
  { countryId: 127468, value: 'Tanzania, United Republic Of', code: 'TZ' },
  { countryId: 127457, value: 'Thailand', code: 'TH' },
  { countryId: 127460, value: 'Timor-leste', code: 'TL' },
  { countryId: 127456, value: 'Togo', code: 'TG' },
  { countryId: 127459, value: 'Tokelau', code: 'TK' },
  { countryId: 127463, value: 'Tonga', code: 'TO' },
  { countryId: 127465, value: 'Trinidad And Tobago', code: 'TT' },
  { countryId: 127462, value: 'Tunisia', code: 'TN' },
  { countryId: 127464, value: 'Turkey', code: 'TR' },
  { countryId: 127461, value: 'Turkmenistan', code: 'TM' },
  { countryId: 127453, value: 'Turks And Caicos Islands', code: 'TC' },
  { countryId: 127466, value: 'Tuvalu', code: 'TV' },
  { countryId: 127470, value: 'Uganda', code: 'UG' },
  { countryId: 127469, value: 'Ukraine', code: 'UA' },
  { countryId: 127248, value: 'United Arab Emirates', code: 'AE' },
  { countryId: 127321, value: 'United Kingdom', code: 'GB' },
  { countryId: 127472, value: 'United States', code: 'UM' },
  { countryId: 127471, value: 'United States Minor Outlying Islands', code: 'UM' },
  { countryId: 127473, value: 'Uruguay', code: 'UY' },
  { countryId: 127474, value: 'Uzbekistan', code: 'UZ' },
  { countryId: 127481, value: 'Vanuatu', code: 'VU' },
  { countryId: 127477, value: 'Venezuela', code: 'VE' },
  { countryId: 127480, value: 'Viet Nam', code: 'VN' },
  { countryId: 127478, value: 'Virgin Islands, British', code: 'VG' },
  { countryId: 127479, value: 'Virgin Islands, U.S.', code: 'VI' },
  { countryId: 127482, value: 'Wallis And Futuna', code: 'WF' },
  { countryId: 127311, value: 'Western Sahara', code: 'EH' },
  { countryId: 127484, value: 'Yemen', code: 'YE' },
  { countryId: 127487, value: 'Zambia', code: 'ZM' },
  { countryId: 127488, value: 'Zimbabwe', code: 'ZW' }
]

module.exports = countries
